import React, { useEffect }  from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { 
    ELECTRICITY_QUERY,
    GAS_QUERY, 
    FUEL_TYPE_ELECTRICITY, 
    POSTCODE,
    METER_POINT_ADMINISTRATION_NUMBER,
    METER_POINT_REFERENCE_NUMBER,
    METER_SERIAL_NUMBER,
    METHOD_SELECTION_TITLE,
    electricityDomesticEnquiryMethods, 
    gasDomesticEnquiryMethods,
    } from "../../config/AppConfigurator";
import { SelectionCard } from "../../components/SelectionCard/SelectionCard";
import { Title } from '../../components/Title/Title';


/* IMPORT STYLES FOR METER DATA ENQUIRY METHOD SELECTION CONTAINER */ 
import './MeterDataEnquiryMethodSelection.scss';

export const MeterDataEnquiryMethodSelection = ({ }) => {
    const location = useLocation();
    const navigate  = useNavigate();

    useEffect(()=>{
        /* 
        * If user will try yo land directly to this page from url the location object will have null state in that
        * case we will redirect the use to the home page. 
        */ 
        if(location && location.state === null){
            navigate('/');
        }
    },[])

    const MeterDataEnquiryMethodSelectionFactory = (methodName)=> {
        switch(methodName){
            case POSTCODE:
                navigate('/meter-data-enquiry-panel', { state: { fuelType: location.state.fuelType, methodType: methodName } });
                break;
            case METER_POINT_ADMINISTRATION_NUMBER:
                navigate('/meter-data-enquiry-panel', { state: { fuelType: location.state.fuelType, methodType: methodName } });
                break;
            case METER_POINT_REFERENCE_NUMBER:
                navigate('/meter-data-enquiry-panel', { state: { fuelType: location.state.fuelType, methodType: methodName } });
                break;
            case METER_SERIAL_NUMBER:
                navigate('/meter-data-enquiry-panel', { state: { fuelType: location.state.fuelType, methodType: methodName } });
                break;
            default:
                navigate('/');
        }
    }
    
    return (
        <>
            <div className='method-selection-head'>
                {location && location.state && location.state.fuelType === FUEL_TYPE_ELECTRICITY ? 
                    <Title title={ ELECTRICITY_QUERY }/> 
                    :
                    <Title title={ GAS_QUERY }/> 
                }
            </div>
            <div className='method-selection-head method-sub-title'>
                <Title title={ METHOD_SELECTION_TITLE } /> 
            </div>
            <div className='method-selection-options'>
                {
                location && location.state && location.state.fuelType === FUEL_TYPE_ELECTRICITY? 
                <div className="method-selection-cards">
                    <div className="row gy-3">
                        {electricityDomesticEnquiryMethods.map((domesticEnquiryMethod, index)=>{
                                return(
                                    <div key={ index } className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                        <SelectionCard { ...domesticEnquiryMethod } selectionType={MeterDataEnquiryMethodSelectionFactory} />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                :                
                <div className="method-selection-cards">
                    <div className="row gy-3">
                        {gasDomesticEnquiryMethods.map((domesticEnquiryMethod, index)=>{
                                return(
                                <div key={ index } className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <SelectionCard { ...domesticEnquiryMethod } selectionType={ MeterDataEnquiryMethodSelectionFactory } />
                                </div>
                                )
                            })
                        }
                    </div>
                </div>
                }
            </div>
        </>
    );
};
